import {useContext, useEffect, useState} from "react";
import PropTypes from "prop-types";
import DialogTitle from "@material-ui/core/DialogTitle";
import {Dialog, DialogContent, IconButton, Paper, Tooltip, Typography} from "@material-ui/core";
import {Check} from "@material-ui/icons";
import request from "../../../../../../../../../Services/API/Requests";
import {ScreenDesignerContextNew} from "../../../../../../../../../ContextComponents/ScreenDesignerContextNew";

const SelectTemplateDialog = (props) => {
    const {onSelectStyleTemplate} = useContext(ScreenDesignerContextNew);
    const {open, onClose} = props;
    const [data, setData] = useState([]);

    useEffect(() => {
        if (open) {
            //get component image
            getData();

        }
    }, [open]);

    async function getData() {
        try {
            const response = await request({
                url: "/dataSource/getData",
                data: {
                    id: "componentStyleTemplatesDefaultList",
                    pageNumber: 0,
                    pageSize: 99,
                }
            })
            setData(response.content)
        } catch (e) {
            console.log('get templates list error', e);
        }
    }

    function onSelect(item) {
        onSelectStyleTemplate(item.styles)
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={"sm"}>
            <DialogTitle
                style={{
                    padding: '8px 14px',
                    fontSize: '0.5rem'
                }}
            >
                <Typography variant={"h6"}>
                    Select style template
                </Typography>
            </DialogTitle>
            <DialogContent>
                <div>
                    {data.map(item => {
                        return (
                            <Paper key={item.id}
                                   style={{
                                       display: 'flex',
                                       justifyContent: 'space-between',
                                       alignItems: 'center',
                                       width: '100%',
                                       padding: 5,
                                       marginTop: 10
                                   }}
                            >
                                <div style={{
                                    border: '1px dashed #e0e0e0',
                                    padding: 5,
                                    width: '50%'
                                }}>
                                    <img src={item.thumbnail} alt={'component preview'}
                                         style={{
                                             maxWidth: '150px'
                                         }}
                                    />
                                </div>
                                <Typography style={{
                                    paddingLeft: 10,
                                    width: '30%'
                                }}>
                                    {item.name}
                                </Typography>
                                <div>
                                    <Tooltip title={'Select'}>
                                        <IconButton
                                            onClick={() => {
                                                onSelect(item);
                                                onClose();
                                            }}>
                                            <Check/>
                                        </IconButton>
                                    </Tooltip>
                                </div>

                            </Paper>
                        )
                    })}
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default SelectTemplateDialog;
SelectTemplateDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func
}